import React, { Component, Fragment } from 'react'
// import { withController } from 'react-scroll-parallax'
import Banner from './Banner'
import Header from './Header'
import Video from './Video'
import Bundles from './Bundles'
import Live from './Live'
import Footer from './Footer'

class App extends Component {

    componentDidMount() {
        // const { parallaxController } = this.props
        // window.onscroll = function() {
        //     if(window.pageYOffset === 0)
        //         parallaxController.update()
        // }
    }

    render() {
        return (
            <Fragment>
                {/* <Banner
                    text="Order the album from shop.kanomusic.com for priority access to tour tickets*"
                    isDesktop={true}
                /> */}
                <Header />
                <Video />
                <Bundles />
                <Live />
                <Footer />
            </Fragment>
        )
    }
}

// export default withController(App)
export default App
